import TextArea from 'antd/es/input/TextArea'
import clsx from 'clsx'
import React from 'react'

import styles from './pure-text-area.module.scss'

interface PureTextAreaProps {
  name?: string
  id?: string
  label?: string
  placeholder?: string
  maxLength?: number
  colClass?: string
  moduleStyle?: string
  disabled?: boolean
  value?: string | null
  required?: boolean
  isBuilder?: boolean
  error?: string | string[]
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement> | string) => void
  onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void
  onKeyDown?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void
}

export const PureTextArea = ({
  name,
  id,
  label,
  onChange,
  onBlur,
  value,
  error,
  disabled,
  placeholder,
  maxLength,
  colClass,
  moduleStyle,
  onKeyDown,
  required = false,
  isBuilder = false,
}: PureTextAreaProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (isBuilder) {
      onChange?.({
        persist: () => {},
        target: {
          name: (name ?? '') as any,
          value: e.target.value,
        },
      } as any)
    } else {
      onChange?.(e.target.value)
    }
  }

  return (
    <div className={clsx(colClass || 'col-12', moduleStyle || '', styles.textAreaStyles)}>
      {label ? (
        <div className="label d-block mt-3 mb-1">
          {label}
          {required ? <span className={clsx('requiredAsterisk')}>*</span> : null}
        </div>
      ) : null}
      <TextArea
        disabled={disabled}
        id={id || name}
        maxLength={maxLength}
        name={name}
        onBlur={onBlur}
        onChange={handleChange}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        value={value ?? ''}
      />
      {error ? <div className="error-message mt-1 text-danger">{Array.isArray(error) ? error[0] : error}</div> : null}
    </div>
  )
}
